import { render, staticRenderFns } from "./libroRemuneracionesClon.vue?vue&type=template&id=5ea890e2&"
import script from "./libroRemuneracionesClon.vue?vue&type=script&lang=js&"
export * from "./libroRemuneracionesClon.vue?vue&type=script&lang=js&"
import style0 from "./libroRemuneracionesClon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports